<template>
  <div class="new-block-content">
    <div class="new-block-title">
      <div class="new-block-text">最新区块</div>
      <div class="new-block-img"></div>
    </div>

    <div class="block-height-left">
      <div class="new-block-time">
        <p class="block-date">创建时间</p>
        <p class="block-time">{{ tableData[0].createAt }}</p>
      </div>
      <div class="new-block-list">
        <p class="block-label">Block {{ tableData[0].blockHeight }}</p>
        <p class="block-hash">{{ tableData[0].blockHash }}</p>
      </div>
      <div class="block-height-label">区块高度</div>
    </div>

    <div class="block-height-left">
      <div class="new-block-list">
        <p class="block-label">Block {{ tableData[1].blockHeight }}</p>
        <p class="block-hash">{{ tableData[1].blockHash }}</p>
      </div>
      <div class="new-block-time">
        <p class="block-date">创建时间</p>
        <p class="block-time">{{ tableData[1].createAt }}</p>
      </div>
      <div class="block-height-label">区块高度</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import '@/styles/compatible/index.scss'

export default {
  name: 'Transactions',
  components: {},
  data() {
    return {
      intervalId: null,
      tableData: []
    }
  },
  computed: {},
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getBlockListFn()
    }
  },
  mounted() {
    this.getBlockListFn()
    this.intervalId = setInterval(() => {
      this.getBlockListFn()
    }, 10000)
  },
  methods: {
    // 获取最新区块列表
    ...mapActions(['getBlockLists']),
    getBlockListFn() {
      let cid = this.$store.state.home.chainCid

      let params = {
        offset: 1,
        limit: 10,
        // chainId: this.$store.state.home.chainCid
        chainId: cid
      }

      this.getBlockLists(params).then(res => {
        res.items.forEach(item => {
          item.createAt = item.createAt.substring(5, 19).replace('T', '  ')
        })
        this.tableData = res.items.slice(0, 2)
        this.$store.commit('updateLoading', false)
      })
    },
    handleCurrentChange(page) {
      this.pageData.page = page
      this.getList()
    },
    rowClass({ row, rowIndex }) {
      return 'background:none;border:none;color:#00CBFF!important;font-size:14px;text-align:right;'
    },
    $px2vw(property, value, base = 1920) {
      const numValue = parseFloat(value)
      if (typeof numValue === 'number' && !isNaN(numValue)) {
        return `${(numValue / base) * 100}vw`
      }
      return value
    },
    formatTime(time) {
      const date = new Date(time)
      return date
        .toLocaleString()
        .replace(/\//g, '-')
        .replace(/\b\d\b/g, '0$&') // 转换为本地时间字符串
    }
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/compatible/index.scss';

:root {
  --design-width: 1920px;
}

.new-block-content .block-height-left:nth-child(odd) {
  background-image: url('../../../assets/images/char/block_height_right.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;

  @include px2vw(width, 350);
  @include px2vw(height, 114);

  @include px2vw(margin-left, 80);
  @include px2vw(margin-top, -10);

  position: relative;
  display: flex;

  .new-block-time {
    @include px2vw(width, 62);
    @include px2vw(height, 51);
    @include px2vw(margin-top, 30);
    @include px2vw(margin-left, 32);
    @include px2vw(line-height, 30);

    text-align: center;

    .block-date {
      @include px2vw(width, 56);
      @include px2vw(font-size, 14);
      color: $titleColor;
      margin: 0;
      // font-style: italic;
      text-align: center;
    }

    .block-time {
      margin: 0;
      text-align: center;
      @include px2vw(line-height, 14);
      @include px2vw(font-size, 14);

      // font-style: italic;
    }
  }

  .new-block-list {
    @include px2vw(height, 51);
    @include px2vw(margin-left, 30);
    @include px2vw(margin-top, 30);
    @include px2vw(line-height, 22);

    .block-label {
      margin: 0;
      @include px2vw(font-size, 14);
    }

    .block-hash {
      margin: 0;
      @include px2vw(width, 200);
      @include px2vw(line-height, 14);
      @include px2vw(font-size, 14);

      text-overflow: ellipsis;
      overflow: hidden;
      color: #b7cffc;
    }
  }

  .block-height-label {
    position: absolute;
    @include px2vw(font-size, 18);
    // font-style: italic;
    color: $titleColor;
    @include px2vw(left, 44);
    @include px2vw(top, 6);
  }
}

.new-block-content .block-height-left:nth-child(even) {
  background-image: url('../../../assets/images/char/block_height_left.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  @include px2vw(width, 350);
  @include px2vw(height, 114);
  @include px2vw(margin-left, 48);
  @include px2vw(margin-top, 10);
  position: relative;
  display: flex;

  .new-block-list {
    @include px2vw(width, 238);
    @include px2vw(height, 51);
    @include px2vw(padding-top, 30);
    @include px2vw(padding-left, 24);
    @include px2vw(line-height, 22);

    .block-label {
      margin: 0;
      @include px2vw(font-size, 14);
    }

    .block-hash {
      margin: 0;
      @include px2vw(width, 200);
      @include px2vw(line-height, 14);
      @include px2vw(font-size, 14);
      color: #b7cffc;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .new-block-time {
    @include px2vw(width, 62);
    @include px2vw(height, 51);
    @include px2vw(margin-top, 30);
    @include px2vw(margin-left, 25);
    @include px2vw(line-height, 30);

    .block-date {
      @include px2vw(width, 56);
      @include px2vw(font-size, 14);
      color: $titleColor;
      margin: 0;
      // font-style: italic;
      text-align: center;
    }

    .block-time {
      margin: 0;
      text-align: center;
      @include px2vw(line-height, 14);
      @include px2vw(font-size, 14);

      // font-style: italic;
    }
  }

  .block-height-label {
    position: absolute;
    @include px2vw(font-size, 18);
    // font-style: italic;
    color: $titleColor;
    @include px2vw(right, 44);
    @include px2vw(top, 6);
  }
}

.new-block {
  background-image: url('../../../assets/images/char/new_block.png');
  background-repeat: no-repeat;
  background-size: cover;

  .new-block-text {
    @include px2vw(font-size, 18);
    @include px2vw(width, 156);
    font-weight: bold;
    background-image: linear-gradient(to bottom, #b2ccfc, #ffffff);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-weight: bold;
  }

  .new-block-img {
    background-image: url('../../../assets/images/char/titleLine.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .block-height-left {
  }

  .block-height-right {
  }
}
</style>
